import { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import { slugify } from '../utils/slugify';

export function useProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetch = async () => {
    setLoading(true);
    setError(null);
    const { data, error: err } = await supabase
      .from('products')
      .select('*')
      .order('created_at', { ascending: false });
    if (err) setError(err.message);
    setProducts(data || []);
    setLoading(false);
  };

  useEffect(() => { fetch(); }, []);

  return { products, loading, error, refetch: fetch };
}

export function useProduct(slug) {
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const { data } = await supabase.from('products').select('*');
      const found = (data || []).find(p => slugify(p.name) === slug);
      if (found) {
        setProduct(found);
        setRelated((data || []).filter(p => p.category === found.category && p.id !== found.id).slice(0, 3));
      } else {
        setProduct(null);
      }
      setLoading(false);
    };
    load();
  }, [slug]);

  return { product, loading, related };
}
